import { takeEvery, put } from 'redux-saga/effects';
import * as types from './constants';
import { Layout } from '@components/layout'

function* rootSagas() {
    yield takeEvery([
        types.UPDATE_MODULES_CONFIGURATION_REQUEST,
        types.GET_MODULES_CONFIGURATION_REQUEST
    ], (Layout.actions.openPreloaderSaga));
    yield takeEvery([
        types.UPDATE_MODULES_CONFIGURATION_SUCCESS,
        types.UPDATE_MODULES_CONFIGURATION_FAILURE,
        types.GET_MODULES_CONFIGURATION_SUCCESS,
        types.GET_MODULES_CONFIGURATION_FAILURE,
    ], (Layout.actions.closePreloaderSaga));
}

export default rootSagas;